export default {"src":"/login-app/[GIT_HASH]/_next/static/media/open_ai.c45f04f4.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};